/**
 * Takes an existing img src and concats an underscore and the given `namedSize` onto it <br />
 * along with the file type (if it exsists).
 * Possible `namedSizes`:
 * 'compact',
 * 'medium',
 * 'large',
 * 'grande',
 *
 * @param {String} imageSrc - The image src url
 * @param {String} namedSize - Name for a specified dimension (given by shopify)
 * @returns {String} imageSrc_namedSize | imageSrc_namedSize.filetype
 */
export const createImgSrc = (imageSrc, namedSize) => {
  const src = imageSrc || 'https://cdn.shopify.com/s/files/1/0318/2649/files/placeholder-rectangle.jpg?v=1659916735';

  const index = src.lastIndexOf('.');

  if (index == -1) return `${src}_${namedSize}`;

  return `${src.substring(0, index)}_${namedSize}${src.substring(index)}`;
};

export default {
  createImgSrc,
};
